import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Checkbox, Form, Radio } from 'antd';
import './style.scss';
import Button from 'components/Button/Button';
import { FormattedMessage, useIntl } from 'react-intl';
import { PaymentService } from 'services/PaymentService';
import { Notification } from 'components';
import sha256 from 'crypto-js/sha256';

const secret_code = 'mYvnpT@P4ymentgW@2021';

const ConfirmPaymentModal = ({ item, isOpenModal, closeModal, confirmAction }) => {
  const [step, setStep] = useState(1);
  const [paySelected, setPaySelected] = useState(0);
  const [listBank, setListBank] = useState([]);

  const intl = useIntl();

  const onSubmit = ({ card }) => {
    if (card === 0) {
      confirmAction();
    } else if (card === 1) {
      paymentPackage("VNPTWALLET");
    } else if (card === 2) {
      getListBank(false);
    } else {
      getListBank(true);
    }
  }

  const getListBank = (isInternal) => {
    setStep(2);
    PaymentService.getListBank({}, res => {
      let banks = res.filter(item => item.IS_INTERNATIONAL === isInternal);
      setListBank(banks);
    })
  }

  const paymentPackage = (bankCode) => {
    const msisdn = localStorage.getItem('mobile');
    const request_time = `${Date.now()}`;
    const product_type = (item.TYPE === 'kmcb' || item.PACKAGE_TYPE === '2') ? "KMCB" : "DATA";

    const data = {
      msisdn,
      package_code: item.CODE,
      pay_method: bankCode,
      product_type,
      request_time,
      trans_id: sha256(`${msisdn}|${request_time}|${item.CODE}|${bankCode}|${product_type}|${secret_code}`).toString()
    }

    PaymentService.paymentPackage(data, res => {
      const secure_code = sha256(`${res.error_code}|${res.message}|${res.redirect_url}|${secret_code}`).toString();
      if (res.error_code === '00' && res.secure_code === secure_code) {
        sessionStorage.setItem('packageName', item.NAME);
        sessionStorage.setItem('package_id', item.ID);
        window.location.assign(res.redirect_url);
      } else {
        Notification.error(res.message);
      }
    })
  }

  const onChange = (e) => {
    setPaySelected(e.target.value);
  }

  return (
    <Modal show={isOpenModal} onHide={closeModal} className="confirm-pay">
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage id='IDS_TV_CHON_CACH_THANH_TOAN' /></Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {step === 1 &&
          <>
            <h6 className="text-center mb-3 blue text-600">Chọn hình thức thanh toán</h6>
            <Form onFinish={onSubmit} initialValues={{ card: 0 }}>
              <Form.Item name="card" rules={[
                {
                  required: true,
                  message: intl.formatMessage({ id: 'IDS_VALIDATION_VPLUS_USERNAME_LENGTH' }),
                },
              ]}>
                <Radio.Group className="d-block confirm-pay__radio-group" onChange={onChange}>
                  <Radio value={0}><FormattedMessage id='IDS_TV_MAIN_ACCT' /></Radio>
                  {item.STATUS_PAY === '1' &&
                    <>
                      <Radio value={1}><FormattedMessage id='IDS_TV_VNPT_PAY' /></Radio>
                      <Radio value={2}><FormattedMessage id='IDS_TV_THE_NOI_DIA' /></Radio>
                      <Radio value={3}><FormattedMessage id='IDS_TV_THE_QUOC_TE' /></Radio>
                    </>
                  }
                </Radio.Group>
              </Form.Item>

              {paySelected !== 0 &&
                <Form.Item
                  name="agreement"
                  valuePropName="checked"
                  rules={[
                    {
                      validator: (_, value) =>
                        value ? Promise.resolve() : Promise.reject(new Error(intl.formatMessage({ id: 'IDS_VALIDATION_VPLUS_USERNAME_LENGTH' }))),
                    },
                  ]}
                >
                  <Checkbox>Tôi xác nhận động ý với điều khoản dịch vụ và chính sách quyền riêng tư của ví VNPTPay</Checkbox>
                </Form.Item>
              }

              <div className="confirm-pay__btn">
                <Button primeBtn onClick={closeModal} buttonClass="mr-3">
                  <FormattedMessage id='IDS_SHUYDV' />
                </Button>
                <Button type="submit">
                  <FormattedMessage id='IDS_TV_THANHTOAN' />
                </Button>
              </div>
            </Form>
          </>
        }

        {step === 2 &&
          <div className="box-bank">
            {listBank.map((item, index) => (
              <React.Fragment key={index}>
                {item.BANK_CODE !== 'VNPTWALLET' &&
                  <img
                    src={item.BANK_LOGO_URL}
                    alt={item.BANK_NAME}
                    onClick={() => paymentPackage(item.BANK_CODE)}
                  />
                }
              </React.Fragment>
            ))}
          </div>
        }
      </Modal.Body>
    </Modal>
  )
}

export default React.memo(ConfirmPaymentModal);